var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`chart school-engagement md-layout-item md-size-${_vm.width} md-medium-size-${_vm.width} md-small-size-100`},[_c('div',{staticClass:"school-engagement"},[_c('h2',[_vm._v(_vm._s(_vm.label))]),_c('div',{},[_c('apexchart',{attrs:{"type":"bar","height":"360","options":_vm.chartOptions,"series":_vm.series}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }